import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Checkbox,
  Slider,
  IconButton,
  Collapse,
  InputBase,
  Paper,
  Divider,
  Button,
} from "@mui/material";
import {
  AddOutlined,
  ExpandLess,
  ExpandMore,
  Remove,
  Search,
} from "@mui/icons-material";
import searchIcon from "../assets/browse-job/search-icon.svg";
import graphIcon from "../assets/browse-job/graph.svg";
import graphIcon2 from "../assets/browse-job/graph2.png";
import axios from "axios";
import API from "../api";
import FilterDrawer from "./FilterDrawer";
const FilterSidebar = ({
  locations,
  specialities,
  onApplyFilters,
  onClearFilters,
  initialFilters = {},
  isFilterVisible,
  setIsOpen,
  isOpen,
}) => {
  const [openSpecialty, setOpenSpecialty] = useState(true);
  const [openPayRate, setOpenPayRate] = useState(true);
  const [openLocation, setOpenLocation] = useState(true);
  const [openShift, setOpenShift] = useState(true);

  const [selectedSpecialties, setSelectedSpecialties] = useState(
    initialFilters.specialties || []
  );
  const [payRate, setPayRate] = useState([
    initialFilters.pay_rate_min || 1,
    initialFilters.pay_rate_max || 50000,
  ]);
  const [selectedLocations, setSelectedLocations] = useState(
    initialFilters.locations || []
  );
  const [selectedShifts, setSelectedShifts] = useState(
    initialFilters.shifts || []
  );

  const shifts = ["Day", "Night"];

  const handleToggle = (section) => {
    if (section === "specialty") setOpenSpecialty((prev) => !prev);
    if (section === "payRate") setOpenPayRate((prev) => !prev);
    if (section === "location") setOpenLocation((prev) => !prev);
    if (section === "shift") setOpenShift((prev) => !prev);
  };

  const handleSpecialtyChange = (specialty) => {
    setSelectedSpecialties((prev) =>
      prev.includes(specialty)
        ? prev.filter((item) => item !== specialty)
        : [...prev, specialty]
    );
  };

  const handlePayRateChange = (event, newValue) => {
    setPayRate(newValue);
  };

  const handleShiftChange = (shift) => {
    setSelectedShifts((prev) =>
      prev.includes(shift)
        ? prev.filter((item) => item !== shift)
        : [...prev, shift]
    );
  };
  const handleLocationChange = (location) => {
    setSelectedLocations((prev) =>
      prev.includes(location)
        ? prev.filter((item) => item !== location)
        : [...prev, location]
    );
  };
  const handleApplyFilters = () => {
    onApplyFilters({
      specialties: selectedSpecialties,
      pay_rate_min: payRate[0],
      pay_rate_max: payRate[1],
      locations: selectedLocations,
      shifts: selectedShifts,
    });
  };

  const handleClearFilters = () => {
    // Reset all filter states
    setSelectedSpecialties([]);
    setPayRate([1000, 50000]);
    setSelectedLocations([]);
    setSelectedShifts([]);

    // Call clear filters function
    onClearFilters();
  };
  const [searchQuery, setSearchQuery] = useState("");
  const [searchLocation, setSearchLocation] = useState("");

  // Filter specialties based on search query
  const filteredSpecialties = specialities.filter((specialty) =>
    specialty.name.toLowerCase().includes(searchQuery.toLowerCase())
  );
  const filteredLocations = locations.filter((location) =>
    location.name.toLowerCase().includes(searchLocation.toLowerCase())
  );
  return (
    <>
      <FilterDrawer
        locations={locations}
        specialities={specialities}
        onApplyFilters={handleApplyFilters}
        onClearFilters={handleClearFilters}
        initialFilters={initialFilters}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        setSelectedSpecialties={setSelectedSpecialties}
        selectedSpecialties={selectedSpecialties}
        setPayRate={setPayRate}
        payRate={payRate}
        selectedLocations={selectedLocations}
        setSelectedLocations={setSelectedLocations}
        selectedShifts={selectedShifts}
        setSelectedShifts={setSelectedShifts}
      />
      <Box
        sx={{
          display: { xs: "none", md: "block" },
          width: { xs: "100%", xl: "294px" },
          pt: 1,
          pb: 2,
          px: 1,
          backgroundColor: "#FFFFFF",
        }}
      >
        {/* Specialty Section */}
        <Box>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography
              variant="subtitle1"
              sx={{
                fontWeight: 600,
                fontSize: { xs: "0.8rem", xl: "18px" },
                lineHeight: { xs: "20px", xl: "24px" },
                fontFamily: "'Montserrat', sans-serif",
              }}
            >
              Speciality
            </Typography>
            <IconButton
              size="small"
              onClick={() => handleToggle("specialty")}
              sx={{
                bgcolor: "transparent !important",
                "&:hover": {
                  bgcolor: "transparent !important",
                },
              }}
            >
              {openSpecialty ? (
                <Remove
                  sx={{
                    color: "black !important",
                    fontSize: {
                      xs: "1.2rem !important",
                      xl: "1.5rem !important",
                    },
                  }}
                />
              ) : (
                <AddOutlined
                  sx={{
                    color: "black !important",
                    fontSize: {
                      xs: "1.2rem !important",
                      xl: "1.5rem !important",
                    },
                  }}
                />
              )}
            </IconButton>
          </Box>
          <Collapse
            in={openSpecialty}
            className="thin_slider"
            sx={{ maxHeight: "300px", overflowY: "auto", mb: 2 }}
          >
            <Box
              sx={{
                position: "sticky",
                top: 0,
                p: { xs: "2px 8px", xl: "8px 1rem" },
                display: "flex",
                alignItems: "center",
                border: "1px solid black",
                borderRadius: { xs: "10px", xl: "15px" },
                my: { xs: "0.8rem", xl: "24px" },

                zIndex: 99,
                bgcolor: "#FFFFFF",
              }}
            >
              <InputBase
                sx={{
                  flex: 1,
                  py: 0,
                  minHeight: "0px !important",
                  m: 0,
                  fontSize: "0.7rem !important",
                }}
                placeholder="Search by Nurses"
                inputProps={{ "aria-label": "search by Nurses" }}
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)} // Update the search query
              />
              <IconButton
                type="button"
                aria-label="search"
                // sx={{ height: "0px", width: "0px" }}
                sx={{
                  bgcolor: "transparent !important",
                  "&:hover": {
                    bgcolor: "transparent !important",
                  },
                }}
              >
                {/* <Search sx={{ fontSize: "1rem" }} /> */}

                <Box
                  component={"img"}
                  src={searchIcon}
                  alt="search job"
                  sx={{
                    width: { xs: "15px", xl: "24px" },
                    height: { xs: "24px" },
                  }}
                />
              </IconButton>
            </Box>

            {filteredSpecialties?.map((specialty, index) => (
              <Box
                key={index}
                display="flex"
                alignItems="center"
                sx={{ marginBottom: 1 }}
              >
                <Checkbox
                  size="small"
                  sx={{ padding: 0, marginRight: 0.5 }}
                  checked={selectedSpecialties?.includes(specialty?.id)}
                  onChange={() => handleSpecialtyChange(specialty?.id)}
                />
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: { xs: "0.8rem", xl: "1rem" },
                    fontWeight: { xs: 400 },
                    lineHeight: { xs: "20px", xl: "26px" },
                    fontFamily: "'Karla', sans-serif",
                  }}
                >
                  {specialty?.name}
                </Typography>
              </Box>
            ))}
          </Collapse>
        </Box>
        <Divider sx={{ bgcolor: "#CCCCCC" }} />
        {/* Pay Rate Range Section */}
        <Box mt={3}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography
              variant="subtitle1"
              sx={{
                fontWeight: 600,
                fontSize: { xs: "0.8rem", xl: "18px" },
                lineHeight: { xs: "20px", xl: "24px" },
                fontFamily: "'Montserrat', sans-serif",
              }}
            >
              Pay rate range (hourly)
            </Typography>
            <IconButton size="small" onClick={() => handleToggle("payRate")}>
              {openPayRate ? (
                <Remove
                  sx={{
                    color: "black !important",
                    fontSize: {
                      xs: "1.2rem !important",
                      xl: "1.5rem !important",
                    },
                  }}
                />
              ) : (
                <AddOutlined
                  sx={{
                    color: "black !important",
                    fontSize: {
                      xs: "1.2rem !important",
                      xl: "1.5rem !important",
                    },
                  }}
                />
              )}
            </IconButton>
          </Box>
          <Collapse in={openPayRate}>
            <Box display="flex" justifyContent="space-between" mt={1} mb={2}>
              <Box sx={{ width: "45%" }}>
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontWeight: 700,
                    fontSize: { xs: "0.7rem", xl: "17px" },
                    lineHeight: { xs: "20px", xl: "24px" },
                    fontFamily: "'Karla', sans-serif",
                    mb: 0.5,
                  }}
                >
                  Min (USD)
                </Typography>
                <InputBase
                  value={payRate[0]}
                  onChange={(e) => {
                    e.target.value >= 0 &&
                      setPayRate([+e.target.value, payRate[1]]);
                  }}
                  variant="outlined"
                  sx={{
                    p: { xs: "2px 8px", xl: "8px 1rem" },
                    border: "1px solid #000000",
                    borderRadius: { xs: "4px" },

                    py: 0,
                    minHeight: "0px",
                    m: 0,
                    fontSize: "0.7rem",
                    height: "34px",
                  }}
                  placeholder=" "
                  inputProps={{ "aria-label": "search by Nurses" }}
                />
              </Box>
              <Box sx={{ width: "45%" }}>
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontWeight: 700,
                    fontSize: { xs: "0.7rem", xl: "17px" },
                    lineHeight: { xs: "20px", xl: "24px" },
                    fontFamily: "'Karla', sans-serif",
                    mb: 0.5,
                  }}
                >
                  Max (USD)
                </Typography>
                <InputBase
                  value={payRate[1]}
                  onChange={(e) => {
                    e.target.value >= 0 &&
                      setPayRate([payRate[0], +e.target.value]);
                  }}
                  variant="outlined"
                  min={0}
                  sx={{
                    p: { xs: "2px 8px", xl: "8px 1rem" },
                    border: "1px solid #000000",
                    borderRadius: { xs: "4px" },

                    py: 0,
                    minHeight: "0px",
                    m: 0,
                    fontSize: "0.7rem",
                    height: "34px",
                  }}
                  placeholder=" "
                  inputProps={{ "aria-label": "search by Nurses" }}
                />
              </Box>
            </Box>
            <Box
              sx={{
                position: "relative !important",
                width: "95% !important",
                mt: 5,
              }}
            >
              <Slider
                value={payRate}
                min={0}
                max={50000}
                onChange={handlePayRateChange}
                valueLabelDisplay="auto"
                sx={{
                  color: "#E9C369",
                  "& .MuiSlider-thumb": {
                    borderRadius: 4,
                    width: { xs: "18px", xl: "24px" },
                    height: { xs: "18px", xl: "24px" },
                  },
                  "& .MuiSlider-track": {
                    color: "#A1A1A1",
                    height: { xs: "2px", xl: "4px" },
                  },
                }}
              />
              <Box
                component={"img"}
                src={graphIcon2}
                alt="search job"
                sx={{
                  width: { xs: "100% !important", xl: "255px !important" },
                  position: "absolute !important",
                  left: 0,
                  top: { xs: "-6vh", xl: "-2.5rem" },
                }}
              />
            </Box>
          </Collapse>
        </Box>

        <Divider sx={{ bgcolor: "#CCCCCC" }} />
        {/* Location Section */}
        <Box mt={3}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography
              variant="subtitle1"
              sx={{
                fontWeight: 600,
                fontSize: { xs: "0.8rem", xl: "18px" },
                lineHeight: { xs: "20px", xl: "24px" },
                fontFamily: "'Montserrat', sans-serif",
              }}
            >
              Location
            </Typography>
            <IconButton
              size="small"
              onClick={() => handleToggle("location")}
              sx={{
                bgcolor: "transparent !important",
                "&:hover": {
                  bgcolor: "transparent !important",
                },
              }}
            >
              {openLocation ? (
                <Remove
                  sx={{
                    color: "black !important",
                    fontSize: {
                      xs: "1.2rem !important",
                      xl: "1.5rem !important",
                    },
                  }}
                />
              ) : (
                <AddOutlined
                  sx={{
                    color: "black !important",
                    fontSize: {
                      xs: "1.2rem !important",
                      xl: "1.5rem !important",
                    },
                  }}
                />
              )}
            </IconButton>
          </Box>
          <Collapse
            in={openLocation}
            className="thin_slider"
            sx={{ maxHeight: "300px", overflowY: "auto", mb: 2 }}
          >
            <Box
              sx={{
                position: "sticky",
                top: 0,
                p: { xs: "2px 8px", xl: "8px 1rem" },
                display: "flex",
                alignItems: "center",
                border: "1px solid black",
                borderRadius: { xs: "10px", xl: "15px" },
                my: { xs: "0.8rem", xl: "24px" },

                zIndex: 99,
                bgcolor: "#FFFFFF",
              }}
            >
              <InputBase
                sx={{
                  flex: 1,
                  py: 0,
                  minHeight: "0px",
                  m: 0,
                  fontSize: "0.7rem",
                }}
                placeholder="Search by State"
                inputProps={{ "aria-label": "search by state" }}
                value={searchLocation}
                onChange={(e) => setSearchLocation(e.target.value)}
              />
              <IconButton
                type="button"
                aria-label="search"
                sx={{
                  bgcolor: "transparent !important",
                  "&:hover": {
                    bgcolor: "transparent !important",
                  },
                }}
              >
                {/* <Search sx={{ fontSize: "1rem" }} /> */}

                <Box
                  component={"img"}
                  src={searchIcon}
                  alt="search job"
                  sx={{
                    width: { xs: "15px", xl: "24px" },
                    height: { xs: "24px" },
                  }}
                />
              </IconButton>
            </Box>
            {filteredLocations?.map((location, index) => (
              <Box
                key={index}
                display="flex"
                alignItems="center"
                sx={{ marginBottom: 1 }}
              >
                <Checkbox
                  size="small"
                  sx={{ padding: 0, marginRight: 0.5 }}
                  checked={selectedLocations?.includes(location?.id)}
                  onChange={() => handleLocationChange(location?.id)}
                />
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: { xs: "0.8rem", xl: "1rem" },
                    fontWeight: { xs: 400 },
                    lineHeight: { xs: "20px", xl: "26px" },
                    fontFamily: "'Karla', sans-serif",
                  }}
                >
                  {location?.name}
                </Typography>
              </Box>
            ))}
          </Collapse>
        </Box>

        <Divider sx={{ bgcolor: "#CCCCCC" }} />
        {/* Shift type Section */}
        {/* <Box mt={3}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography
              variant="subtitle1"
              sx={{
                fontWeight: 600,
                fontSize: { xs: "0.8rem", xl: "18px" },
                lineHeight: { xs: "20px", xl: "24px" },
                fontFamily: "'Montserrat', sans-serif",
              }}
            >
              Shift type
            </Typography>
            <IconButton size="small" onClick={() => handleToggle("shift")}>
              {openShift ? (
                <Remove
                  sx={{
                    color: "black !important",
                    fontSize: {
                      xs: "1.2rem !important",
                      xl: "1.5rem !important",
                    },
                  }}
                />
              ) : (
                <AddOutlined
                  sx={{
                    color: "black !important",
                    fontSize: {
                      xs: "1.2rem !important",
                      xl: "1.5rem !important",
                    },
                  }}
                />
              )}
            </IconButton>
          </Box>
          <Collapse in={openShift}>
            {shifts.map((shift, index) => (
              <Box
                key={index}
                display="flex"
                alignItems="center"
                sx={{ marginBottom: 1 }}
              >
                <Checkbox
                  size="small"
                  sx={{ padding: 0, marginRight: 0.5 }}
                  checked={selectedShifts.includes(shift)}
                  onChange={() => handleShiftChange(shift)}
                />
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: { xs: "0.8rem", xl: "1rem" },
                    fontWeight: { xs: 400 },
                    lineHeight: { xs: "20px", xl: "26px" },
                    fontFamily: "'Karla', sans-serif",
                  }}
                >
                  {shift}
                </Typography>
              </Box>
            ))}
          </Collapse>
        </Box> */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            mt: 2,
            width: "90%",
          }}
        >
          <Button
            variant="outlined"
            onClick={handleClearFilters}
            sx={{
              flex: 1,
              mr: 1,
              color: "text.secondary",
              borderRadius: "8px !important",
              "&:hover": {
                bgcolor: "transparent",
                border: " 1px solid rgba(41, 155, 141, 0.5) !important",
                color: " rgb(102, 102, 102) !important",
              },
            }}
          >
            Clear
          </Button>
          <Button
            variant="contained"
            onClick={handleApplyFilters}
            sx={{
              flex: 1,
              bgcolor: "#299B8D",
              borderRadius: "8px !important",
              "&:hover": {
                bgcolor: "#1E7B6E",
              },
            }}
          >
            Apply
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default FilterSidebar;
